import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from './../elements/Image';

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import { EffectCoverflow, Navigation } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

const Team = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'section',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'section-inner'
  );

  const tilesClasses = classNames(
    'tiles-wrap',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: 'Our Team'
  };

  var amountOfSlides = 1;

  if(window.innerWidth > 600 && window.innerWidth < 900){
    amountOfSlides = 2;
  }
  else if(window.innerWidth > 900 && window.innerWidth < 1200){
    amountOfSlides = 3;
  }
  else if(window.innerWidth > 1200){
    amountOfSlides = 4;
  }

  const Slide = ({ imgSource, name, title, description, backgroundColor }) => {
    return (
      <div className='team-slide-container'>
        <div className='team-img-container' style={{ backgroundColor }}>
          <Image src={imgSource} />
        </div>
        <div className='team-slide-occupation'>
          <div className='team-slide-name'>
            {name}
          </div>
          <div>{title}</div>
          <div className='team-slide-description'>{description}</div>
        </div>
      </div>
    );
  }

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div>
        <div className={innerClasses}>
        <SectionHeader data={sectionHeader} className="center-content reveal-from-bottom" data-reveal-delay="200" />
        <h2 className='team-section-text center-content' data-reveal-delay="200">It takes the world's best talent to change the game.</h2>
          <div className={tilesClasses}>
            <Swiper
              speed={500}
              effect={"coverflow"}
              loop={true}
              loopedSlides={20}
              // loopPreventsSlide={false}
              preventClicks={false}
              slidesPerView={amountOfSlides}
              grabCursor={true}
              navigation={true}
              centeredSlides={true}
              slideToClickedSlide={true}
              coverflowEffect={{
                rotate: 20,
                stretch: 0,
                depth: 100,
                modifier: 0.8,
                slideShadows: false,
              }}
              pagination={false}
              // https://github.com/nolimits4web/swiper/issues/4370
              threshold={2}
              resistanceRatio={0.5}
              modules={[EffectCoverflow, Navigation]}
              className="mySwiper"
              onSlideChange={(s) => {
                setTimeout(() => {
                  if (s && s.slides) {
                    for (let i = 0; i < s.slides.length; i++) {
                      const currSlide = s.slides[i];
                      const descriptionDiv = currSlide.querySelector(".team-slide-description");
                      if (descriptionDiv) {
                        descriptionDiv.classList.remove("team-description-transition");
                      }
                    }
                     
                    if (s.activeIndex != undefined) {
                      const activeSlide = s.slides[s.activeIndex];
                      const descriptionDiv = activeSlide.querySelector(".team-slide-description");
                      if (descriptionDiv) {
                        descriptionDiv.classList.add("team-description-transition");
                      }
                    }
                  }
                }, 450);
              }}
            >
              <SwiperSlide>
                <Slide
                  imgSource={require('./../../assets/images/Developer1.png')}
                  name="Seal"
                  title="Blockchain Developer"
                  description={<>
                                • Product development for Amazon &amp; Microsoft<br/>
                                • Formation.dev tech mentor (4 million USD seed funding)<br/>
                                </>}
                  backgroundColor={"#acddde"}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Slide
                  imgSource={require('./../../assets/images/Aylex.png')}
                  name="Albatross"
                  title="Director"
                  description={<>
                                • AylexTV Inc. Founder (4.3+ million social media followers)<br/>
                                • Founder of Boy with Balloon NFT<br/>
                                • Tedx speaker<br/>
                                </>}
                  backgroundColor={"#caf1de"}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Slide
                  imgSource={require('./../../assets/images/Artist.png')}
                  name="Swan"
                  title="Artist &amp; Developer"
                  description={<>
                                • Developer at Amazon, SAP, FinTech startup<br/>
                                • Launched EBT (food stamps) to 44 million people in US<br/>
                                • Developed accounting software, handled over $1B in transactions<br/>
                              </>}
                  backgroundColor={"#e1f8dc"}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Slide
                  imgSource={require('./../../assets/images/Developer3.png')}
                  name="Crocodile"
                  title="Web Developer"
                  description={<>
                                • Desktop and mobile app development<br/>
                                • Adobe Photoshop, Premiere, Illustrator, Blender<br/>
                              </>}
                  backgroundColor={"#ffe7c7"}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Slide
                  imgSource={require('./../../assets/images/James.png')}
                  name="Crocodile"
                  title="Web Developer"
                  description={<>
                                • <br/>
                                • <br/>
                              </>}
                  backgroundColor={"#acddde"}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Slide
                  imgSource={require('./../../assets/images/Jane.png')}
                  name="Jaguar"
                  title="Operations &amp; Design"
                  description={<>
                                • Branding, content creation, &amp; operations at AylexTV Inc. (4.3+ million followers)<br/>
                                • Adobe Photoshop, Premier Pro, Illustrator, Lightroom, After Effects<br/>
                              </>}
                  backgroundColor={"#caf1de"}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Slide
                  imgSource={require('./../../assets/images/Lucien.png')}
                  name="Lizard"
                  title="Case Study Advisor"
                  description={<>
                                • Case study analytics &amp; strategy<br/>
                                • 2.5x+ ROI CryptoSkulls, Candy Digital, Sandbox, $LOOKS, $ENS, $SOS, 20x ROI VeeFriends, 0.5eth to 15eth<br/>
                              </>}
                  backgroundColor={"#e1f8dc"}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Slide
                  imgSource={require('./../../assets/images/Developer4.png')}
                  name="Turtle"
                  title="Game Developer"
                  description={<>
                                • Video game development<br/>
                                • AAA game company in UK<br/>
                              </>}
                  backgroundColor={"#fef8dd"}
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}

Team.propTypes = propTypes;
Team.defaultProps = defaultProps;

export default Team;
